import { ReactNode } from 'react';

import { Content, Root, tileDrawerStepperClasses } from './styles';
import useTileDrawerStepper, { EnumOrObject, UseTileDrawerStepper } from './vm';

export interface TileDrawerStepperProps<Steps extends EnumOrObject<any>> extends UseTileDrawerStepper<Steps> {
  header: ReactNode;
  children: (stepperProps: {
    currentStep: Steps[keyof Steps];
    goToStep: (step: Steps[keyof Steps]) => void;
    goToPreviousStep: () => void;
    goToNextStep: () => void;
  }) => ReactNode;
}

const TileDrawerStepper = <Steps extends EnumOrObject<any>>({
  header,
  children,
  ...vmProps
}: TileDrawerStepperProps<Steps>) => {
  const { steps } = vmProps;
  const { currentStep, goToStep, goToPreviousStep, goToNextStep } = useTileDrawerStepper(vmProps);

  const stepValues = Object.values(steps);
  /** Type casting just for outer world to believe that they are getting correct type */
  const currentStepValue = stepValues.indexOf(currentStep) as Steps[keyof Steps];

  return (
    <Root>
      {header}
      <Content className={tileDrawerStepperClasses.content}>
        {children({ currentStep: currentStepValue, goToStep, goToPreviousStep, goToNextStep })}
      </Content>
    </Root>
  );
};

export default TileDrawerStepper;
